import { useState } from "react";

import {
	Avatar,
	Box,
	Button,
	FormControl,
	FormControlLabel,
	FormHelperText,
	FormLabel,
	Radio,
	RadioGroup,
	TextField,
	Typography,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";

import { Create, getAllBrand, UpdateBrand } from "../../apis/Brand";
import { ImageCropper } from "../CommonFunctions/ImageCropper";
import FormWrapper from "../Form/FormWrapper";
import { showToast } from "../../utils/toast";

export const EditBrandDrawer = ({
	rowsCount,
	page,
	setEditOpen,
	edit,
	brand,
	setRows,
	setBrand,
	setLoading,
}) => {
	const {
		register,
		handleSubmit,
		control,
		formState: { errors },
	} = useForm();

	const [filename, setFilename] = useState("");

	const [crop, setCrop] = useState(false);
	const [image, setImage] = useState(brand.logo ? brand.logo?.file : null);

	const handleInputChange = (e) => {
		console.log("working");
		const { name, value } = e.target;
		setBrand({ ...brand, [name]: value });
	};

	const handleOnChange = (event) => {
		const newImage = event.target?.files?.[0];
		console.log(newImage);
		if (newImage) {
			// console.log(newImage);
			setFilename(newImage.name);
			setImage(URL.createObjectURL(newImage));
			setCrop(true);
		}
	};

	const onSubmit = async (data) => {
		setLoading(true);
		try {
			const formData = new FormData();

			for (const [key, value] of Object.entries(data)) {
				if (key === "file") {
					if (value?.length) {
						const blob = await fetch(image).then((r) => r.blob());
						formData.append("file", blob, filename);
					}
				} else {
					formData.append(key, value);
				}
			}

			const res = edit
				? await UpdateBrand(formData, brand.id)
				: await Create(formData);

			if (res.success) {
				const newBrands = await getAllBrand(rowsCount, page);
				setRows(newBrands.results);
				setEditOpen(false);
				showToast(
					`Brand ${edit ? "Updated" : "Created"} Successfully`,
					"success"
				);
			} else {
				showToast(res.message, "error");
			}
		} catch (err) {
			console.error(err);
			showToast("Something went wrong", "error");
		} finally {
			setLoading(false);
		}
	};

	return (
		<>
			<FormWrapper onSubmit={handleSubmit(onSubmit)} sx={{ p: 5 }}>
				<Box display="flex" justifyContent="space-between">
					<Typography variant="h6" gutterBottom>{`${edit ? "Edit" : "Add"
						} Brand`}</Typography>
					<Button
						type="submit"
						// onClick={handleSave}
						color="primary"
						variant="contained"
					>
						{edit ? "Update" : "Save"}
					</Button>
				</Box>

				<Box my={3}>
					<TextField
						{...register("name", {
							required: "Enter Brand name",
						})}
						fullWidth
						name="name"
						label="Enter Brand Name"
						variant="outlined"
						value={brand.name}
						onChange={handleInputChange}
						error={Boolean(errors.name)}
						helperText={errors.name?.message}
					/>
				</Box>
				<Box my={3}>
					<FormLabel id="locality-group">Seller Market</FormLabel>
					<FormControl
						fullWidth
						error={Boolean(errors.seller_market)}
					>
						<Controller
							control={control}
							defaultValue={
								brand.seller_market ? brand.seller_market : ""
							}
							name="seller_market"
							// onChange={handleInputChange}
							rules={{
								required: "Please pick one from options",
							}}
							render={({ field }) => {
								console.log(field);
								return (
									<RadioGroup
										{...field}
										value={field.value}
										onChange={(e, value) => {
											handleInputChange(e);
											field.onChange(value);
										}}
										row
									>
										<FormControlLabel
											value="Local"
											control={<Radio />}
											label="Local"
										/>
										<FormControlLabel
											value="International"
											control={<Radio />}
											label="International"
										/>
									</RadioGroup>
								);
							}}
						/>

						{Boolean(errors.seller_market) && (
							<FormHelperText>
								{errors.seller_market?.message}
							</FormHelperText>
						)}
					</FormControl>
				</Box>
				{/* <Box my={3}>
						<TextField
							fullWidth
							name="website"
							// style={{ width: "100%" }}
							label="Enter Website url"
							variant="outlined"
							{...register("website", {
								required: "Enter brand website url",
							})}
							error={Boolean(errors.website)}
							helperText={errors.website?.message}
						/>
					</Box> */}

				<Box my={3}>
					<FormControl error={Boolean(errors.file)}>
						{image && (
							<Avatar
								variant="square"
								src={image}
								sx={{
									width: 150,
									height: 150,
									objectFit: "fill",
									marginBottom: 2,
								}}
							/>
						)}
						<Button
							variant="contained"
							component="label"
							onChange={handleOnChange}
						>
							{!image ? "Upload " : "Change "}image
							<input
								hidden
								accept="image/*"
								id="file-upload"
								type="file"
								{...register("file", {
									// required: image == null,
								})}
								error={errors.file}
							/>
						</Button>

						{Boolean(errors.file) && (
							<FormHelperText>Image required</FormHelperText>
						)}
					</FormControl>
				</Box>
			</FormWrapper>

			<ImageCropper
				image={image}
				setImage={setImage}
				open={crop}
				setOpen={setCrop}
				aspect={1}
			/>
		</>
	);
};
